import React__default from 'react';
import { css } from '@emotion/css';
import { useTheme2 } from '@grafana/ui';
import { SelfSignedCertificate } from './SelfSignedCertificate.js';
import { TLSClientAuth } from './TLSClientAuth.js';
import { SkipTLSVerification } from './SkipTLSVerification.js';
import { ConfigSubSection } from '../../ConfigSection/ConfigSubSection.js';
import '@grafana/data';

const TLSSettings = ({ selfSignedCertificate, TLSClientAuth: TLSClientAuth$1, skipTLSVerification, readOnly }) => {
  const { spacing } = useTheme2();
  const styles = {
    container: css({
      marginTop: spacing(3)
    })
  };
  return /* @__PURE__ */ React__default.createElement(
    ConfigSubSection,
    {
      className: styles.container,
      title: "TLS settings",
      description: "Additional security measures that can be applied on top of authentication"
    },
    /* @__PURE__ */ React__default.createElement(SelfSignedCertificate, { ...selfSignedCertificate, readOnly }),
    /* @__PURE__ */ React__default.createElement(TLSClientAuth, { ...TLSClientAuth$1, readOnly }),
    /* @__PURE__ */ React__default.createElement(SkipTLSVerification, { ...skipTLSVerification, readOnly })
  );
};

export { TLSSettings };
//# sourceMappingURL=TLSSettings.js.map
